import store from '@/store'

export default {
  methods: {
    nextStep: async function () {
      await store.dispatch('checkCurrentStep')
      let nextStep = store.getters.getCurrentStep
      if (nextStep === -1) nextStep = 9
      store.dispatch('setCurrentStep', nextStep)
    },
    getUserData: async function () {
      let options = {
        method: 'GET',
        url: process.env.AUTH_BASE + '/profile/',
        headers: {
          'Authorization': `Token ${this.$store.getters.getToken}`,
          'Content-Type': 'application/json'
        }
      }

      const response = await this.httpRequest(options)
      if (response) {
        if (response.status === 200) {
          this.generalInfo = response.data
          this.$store.dispatch('setUserRfc', response.data.rfc)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userProfileMixin.js